var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthdayAndParty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 555.897,
    height: 93.605,
    viewBox: "0 0 555.897 93.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.09;}.b{fill:#44c973;}.c{fill:#45ccff;}.d{fill:#30c9b0;}.e{fill:#fbc640;}.f{fill:#ffabcd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(402.51 -13.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M424.148,214.037a8.044,8.044,0,1,1,8.043-8.043A8.053,8.053,0,0,1,424.148,214.037Z",
    transform: "translate(-324.192 -143.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M224.781,257.941l8.815-8.817,8.817,8.817-8.817,8.815Z",
    transform: "translate(-134.13 -221.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.061,434.627a8.045,8.045,0,1,1,8.045-8.045A8.053,8.053,0,0,1,242.061,434.627Z",
    transform: "translate(-188.327 -345.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M208.667,42.9a8.044,8.044,0,1,1,8.043-8.045A8.054,8.054,0,0,1,208.667,42.9Z",
    transform: "translate(-156.308 -10.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M45.383,185.9a8.044,8.044,0,1,1,8.045-8.043A8.052,8.052,0,0,1,45.383,185.9Z",
    transform: "translate(-29.092 -121.744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.4,375.735c1.8,2.77,2.764,5.959,4.281,8.874a14,14,0,0,0,7.57,7.175,2.25,2.25,0,0,0,2.742-1.557,2.275,2.275,0,0,0-1.557-2.742c-3.156-1.141-4.719-4.538-5.98-7.4-1.4-3.173-2.654-6.428-5.063-9.006-5.742-6.142-14.507-4.158-21.524-1.871-2.716.885-1.554,5.192,1.185,4.3C333.15,371.522,341.167,369.228,345.4,375.735Z",
    transform: "translate(-206.682 -353.364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.987,137.365c-2.869,0-2.873,4.459,0,4.459S141.861,137.365,138.987,137.365Z",
    transform: "translate(-338.61 -47.464)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.393,118.752c-2.869,0-2.873,4.459,0,4.459S173.267,118.752,170.393,118.752Z",
    transform: "translate(-139.078 -98.962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.318,160.438c2.869,0,2.873-4.459,0-4.459S168.444,160.438,171.318,160.438Z",
    transform: "translate(-276.799 -62.966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.153,297.559c-2.869,0-2.873,4.459,0,4.459S5.027,297.559,2.153,297.559Z",
    transform: "translate(0 -221.274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.483,320.631c2.869,0,2.873-4.459,0-4.459S31.61,320.631,34.483,320.631Z",
    transform: "translate(-162.189 -294.775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.639,157.464c2.869,0,2.873-4.459,0-4.459S324.765,157.464,327.639,157.464Z",
    transform: "translate(-229.591 -118.649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.563,190.232c-2.869,0-2.874,4.459,0,4.459S331.436,190.232,328.563,190.232Z",
    transform: "translate(-396.311 -129.653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.259,358.6c-2.869,0-2.873,4.459,0,4.459S480.133,358.6,477.259,358.6Z",
    transform: "translate(-359.163 -255.828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.139,358.889c-.18,3.76,1.845,7.722,6.09,7.632,7.44-.158,10.378-9.449,7.362-15.233a10.947,10.947,0,0,0-2.847-3.477,15.417,15.417,0,0,1,9.086-3.375c2.864-.069,2.875-4.527,0-4.459A20.253,20.253,0,0,0,38.5,345.616a15.456,15.456,0,0,0-10.961.917c-8.187,4-11.126,13.365-11.735,21.81a2.249,2.249,0,0,0,2.229,2.229,2.272,2.272,0,0,0,2.229-2.229c.422-5.852,1.979-11.956,6.528-15.982a11.459,11.459,0,0,1,8.5-2.926c-.041.063-.084.124-.125.188A18.99,18.99,0,0,0,32.139,358.889Zm7.636-7.694c3.191,2.452,3.759,8.116.067,10.336-.711.428-1.862.863-2.588.254-.675-.566-.683-1.777-.667-2.591a14.023,14.023,0,0,1,2.1-6.792c.276-.463.577-.911.9-1.344C39.649,351.1,39.713,351.148,39.775,351.2Z",
    transform: "translate(-418.31 -323.323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.879,181.956a9.6,9.6,0,1,0-9.6-9.6A9.616,9.616,0,0,0,39.879,181.956Zm0-14.751a5.146,5.146,0,1,1-5.145,5.147A5.153,5.153,0,0,1,39.879,167.206Z",
    transform: "translate(50.412 -77.239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.163,19.75a9.6,9.6,0,1,0,9.6,9.6A9.616,9.616,0,0,0,203.163,19.75Zm0,14.751a5.146,5.146,0,1,1,5.145-5.147A5.153,5.153,0,0,1,203.163,34.5Z",
    transform: "translate(-143.803 14.172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.23,33.752a2.222,2.222,0,0,0,1.576-.653l7.871-7.869a2.229,2.229,0,0,0,0-3.153l-7.871-7.871a2.229,2.229,0,0,0-3.153,0l-7.869,7.871a2.23,2.23,0,0,0,0,3.152L42.654,33.1A2.222,2.222,0,0,0,44.23,33.752Zm0-14.817,4.718,4.718L44.23,28.37l-4.717-4.717Z",
    transform: "translate(-328.592 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.069,243.314a2.229,2.229,0,0,0-1.576.653l-7.869,7.871a2.23,2.23,0,0,0,0,3.153l7.869,7.869a2.229,2.229,0,0,0,3.152,0l7.871-7.869a2.229,2.229,0,0,0,0-3.153l-7.871-7.871A2.229,2.229,0,0,0,229.069,243.314Zm0,14.818-4.717-4.717,4.717-4.718,4.718,4.718Z",
    transform: "translate(-548.603 -161.011)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayAndParty);
export default __webpack_public_path__ + "static/media/birthday-and-party.37fbef3dfa778c42498db43f8a073fa0.svg";
export { ForwardRef as ReactComponent };